import { createToaster, type CreateToasterReturn } from '@chakra-ui/react';

export type ToastPosition = 'top' | 'top-right' | 'top-left' | 'bottom' | 'bottom-right' | 'bottom-left';

type ChakraPlacement = 'top' | 'top-start' | 'top-end' | 'bottom' | 'bottom-start' | 'bottom-end';

const positionToPlacement: Record<ToastPosition, ChakraPlacement> = {
  top: 'top',
  'top-right': 'top-end',
  'top-left': 'top-start',
  bottom: 'bottom',
  'bottom-right': 'bottom-end',
  'bottom-left': 'bottom-start',
};

const toasters = new Map<ToastPosition, CreateToasterReturn>();

function getToaster(position: ToastPosition): CreateToasterReturn {
  let toaster = toasters.get(position);
  if (!toaster) {
    toaster = createToaster({ placement: positionToPlacement[position], offsets: '20px' });
    toasters.set(position, toaster);
  }
  return toaster;
}

// one toaster instance per placement, all created up front since Chakra fixes placement per-instance
(Object.keys(positionToPlacement) as ToastPosition[]).forEach(getToaster);

export function getAlertToaster(position: ToastPosition): CreateToasterReturn {
  return getToaster(position);
}

export function getAllAlertToasters(): Map<ToastPosition, CreateToasterReturn> {
  return toasters;
}
